import { Form as BaseForm, FormProps as BaseFormProps } from "@commonlibs";
import { ThemeSpacingValues } from "ui/config/theme/spacing";
import { FormWrapper } from "./Form.styles";

export interface FormProps extends Omit<BaseFormProps, "children"> {
    /**
     * Form children
     */
    children: React.ReactElement | React.ReactElement[];
    /**
     * gap
     */
    gap?: keyof ThemeSpacingValues;
}

const Form = ({ children, gap, ...rest }: FormProps) => {
    return (
        <BaseForm {...rest} css={{ display: "flex" }}>
            <FormWrapper className="form-wrapper" gap={gap}>
                {children}
            </FormWrapper>
        </BaseForm>
    );
};

export default Form;
